export { addComponents } from './commands/add.js';
export { initConfig } from './commands/init.js';
export { listTemplates } from './commands/list.js';
export { validateProject } from './utils/project.js';
export { getTemplateRegistry } from './utils/registry.js';
export type { Template, TemplateRegistry } from './utils/registry.js';